import OperationStatusTimeline from '@/views/operation-details/operation-status-timeline/index.vue';

export default {
    name: 'OperationInfoBox',

    props: ['operation'],

    components: {
        OperationStatusTimeline
    },

    computed: {
        /**
         * Show or hide cancel button
         * @return {Boolean} whether is cancelable or not
         */
        isCancelable() {
            // TODO: ver si permitimos cancelar por aqui,
            // hasta ahora se comprobaban cosas del bpmn que siempre eran falso
            // Para quitar esa referencia devuelvo siempre falso, pero habrá que comprobar que hacemos con esto
            return false;
        },
        /**
         * Show cancel button text
         * @return {String} cancel button text
         */
        cancelText() {
            return this.operation.is_periodic_request ? 'Suspender' : 'Cancelar';
        }
    },
    methods: {
        /**
         * Cancel an operation
         */
        cancelOperation() {
            this.$bvModal.show('modalCancelOperation');
        },
        /**
         * Confirm status change
         */
        confirmCancelOperation() {
            const statusToChange = this.operation.is_periodic_request ? 'PERIODIC_SUSPENDED' : 'CANCELLED';
            this.$operationsService.changeOperationStatus(this.operation.operation_id, { status: statusToChange })
                .then(() => {
                    this.$bvModal.hide('modalCancelOperation');
                    this.$toast.success('OK', 'La operación ha sido anulada correctamente');
                    this.$emit('operationStatusHasChanged');

                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        },
        /**
         * Cancel status change
         */
        cancelCancelOperation() {
            this.$bvModal.hide('modalCancelOperation');
        },
        /**
         * Update operation information on status update
         */
        operationStatusHasChanged() {
            this.$emit('operationStatusHasChanged');
        }
    },
};
